/**
 * OperatorSignedOut.contract.ts — OPERATOR IDENTITY™ Phase 1 (Build 2.06.0).
 * Published when an operator explicitly signs out.
 */

import type { EventContract } from '../EventContractRegistry';

export const OperatorSignedOutContract: EventContract = {
  name: 'OperatorSignedOut',
  version: 1,
  description: 'Published when an operator explicitly signs out.',
  publishers: ['auth-event-service'],
  subscribers: [],
  fields: [
    { name: 'operatorId', type: 'number', required: true, description: 'Operator user ID that signed out' },
  ],
  allowExtraFields: false,
  timestampPolicy: 'Set to Date.now() at publish time.',
  stability: 'stable',
  deprecated: false,
  example: { operatorId: 1 },
};
